(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Feed', Feed);

    /* @ngInject */    
    function Feed($resource) {
        var resourceUrl = 'api/feeds/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
